export default __webpack_public_path__ + "static/media/visa.ca0a7183.svg";